// ============================================================================
//  FormLayout.jsx — Standard Corelia pour l’alignement Label / Champ
// ============================================================================

import React from "react";
import theme from "../../../styles/theme";

const FormLayout = ({
  label,
  labelPosition = "top",         // "top" | "left"
  labelWidth = null,              // ex: "130px"
  align = "center",               // align-items si labelPosition = "left"
  width = "100%",                 // largeur totale du composant
  style = {},
  children,
}) => {

  const isLeft = labelPosition === "left";

  // Espacement uniforme entre label et champ
  const spacingTop =
    labelPosition === "top"
      ? theme.form.field.spacingTop ?? theme.spacing.xs  // typiquement 6–8px
      : 0;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isLeft ? "row" : "column",
        alignItems: isLeft ? align : "flex-start",
        width,
        ...style,
      }}
    >

      {/* === LABEL === */}
      {label && (
        <label
          style={{
            fontFamily: theme.form.label.fontFamily,
            fontSize: theme.form.label.fontSize,
            fontWeight: theme.form.label.fontWeight,
            color: theme.form.label.color,

            // Gestion largeur (mode left uniquement)
            width: isLeft && labelWidth ? labelWidth : "auto",

            // Alignement vertical parfait
            display: "flex",
            alignItems: "center",

            // Espacement vertical uniforme si labelPosition = top
            marginBottom: spacingTop,
          }}
        >
          {label}
        </label>
      )}

      {/* === CHAMP === */}
      <div style={{ width: "100%" }}>
        {children}
      </div>
    </div>
  );
};

export default FormLayout;
